<label class="visually-hidden" [attr.for]="'AriaInput' + id">
	{{field.props.label}}
</label>

@if (!isSensitive)
{
<ng-template [ngIf]="refreshCalendar === false">
	<p-calendar [(ngModel)]="displayDate" [formlyAttributes]="field" [inputStyleClass]="inputStyleClass"
		[showTime]="field.props.showTime" [disabled]="field.props.disabled" hourFormat="12"
		[minDate]="field.props.minDate" showIcon="true" showButtonBar="true" showSeconds="true"
		[showOnFocus]="field.props.showCalendarOnFocus ?? true" [appendTo]="field.props.appendTo"
		[panelStyleClass]="field.props.panelStyleClass" [placeholder]="field.props.placeholder"
		(onSelect)="dateChange($event)" (onInput)="handleInput($event)" (onClearClick)="dateChange($event)"
		[view]="field.props.view || 'date'" [dateFormat]="field.props.dateFormat || 'mm/dd/yy'">
	</p-calendar>

	<ng-template [ngIf]="field.props.quickDateSelection != null">
		<span [pTooltip]="field.props.quickDateSelection.tooltipOptions?.tooltipLabel" tooltipPosition="left"
			tooltipStyleClass="quick-date-tooltip">
			<button type="button" pButton pRipple class="p-button-outlined quick-date-selection ellipsis-text"
				[ngClass]="{
					'p-disabled': (field.props.quickDateSelection.disabled)
				}" [label]="field.props.quickDateSelection.label" [disabled]="field.props.quickDateSelection.disabled"
				(click)="displayDate = field.props.quickDateSelection.command($event); dateChange($event);">
			</button>
		</span>
	</ng-template>
</ng-template>
}
@else
{
<div #sensitiveCalendarContainer class="custom-sensitive-calendar" (focusout)="handleSensitiveFocusOut()">

	<div class="sensitive-calendar-control">
		<div class="sensitive-calendar-field">

			@if (!isRevealed())
			{
			<input [id]="'AriaInput' + id" type="text" [value]="getMaskedValue()" [class]="[
					'p-inputtext',
					'p-component',
					'sensitive-calendar-input',
					'sensitive-masked-calendar-input',
					inputStyleClass
				]" [formlyAttributes]="field" [placeholder]="field.props.placeholder" [disabled]="isDisabled"
				[attr.aria-label]="field.props.label" readonly="true" (click)="revealSensitiveValue()"
				(keydown.enter)="revealSensitiveValue()">
			}
			@else if (!isDisabled)
			{
			<ng-template [ngIf]="refreshCalendar === false">
				<p-calendar [(ngModel)]="displayDate" [formlyAttributes]="field" [inputStyleClass]="inputStyleClass"
					[showTime]="field.props.showTime" [disabled]="field.props.disabled" hourFormat="12"
					[minDate]="field.props.minDate" showIcon="true" showButtonBar="true" showSeconds="true"
					[showOnFocus]="field.props.showCalendarOnFocus ?? true" [appendTo]="field.props.appendTo"
					[panelStyleClass]="field.props.panelStyleClass" [placeholder]="field.props.placeholder"
					(onSelect)="dateChange($event)" (onInput)="handleInput($event)" (onClearClick)="dateChange($event)"
					(onShow)="handleCalendarShow()" (onClose)="handleCalendarClose()"
					[view]="field.props.view || 'date'" [dateFormat]="field.props.dateFormat || 'mm/dd/yy'">
				</p-calendar>

				<ng-template [ngIf]="field.props.quickDateSelection != null">
					<span [pTooltip]="field.props.quickDateSelection.tooltipOptions?.tooltipLabel"
						tooltipPosition="left" tooltipStyleClass="quick-date-tooltip">
						<button type="button" pButton pRipple
							class="p-button-outlined quick-date-selection ellipsis-text" [ngClass]="{
								'p-disabled': (field.props.quickDateSelection.disabled)
							}" [label]="field.props.quickDateSelection.label" [disabled]="field.props.quickDateSelection.disabled"
							(click)="displayDate = field.props.quickDateSelection.command($event); dateChange($event);">
						</button>
					</span>
				</ng-template>
			</ng-template>
			}
			@else
			{
			<input [id]="'AriaInput' + id" type="text" [value]="getRevealedDisplayValue()" [class]="[
					'p-inputtext',
					'p-component',
					'sensitive-calendar-input',
					'sensitive-revealed-calendar-input',
					inputStyleClass
				]" [formlyAttributes]="field" [disabled]="true" [attr.aria-label]="field.props.label" readonly="true">
			}

		</div>

		<button *ngIf="canToggleVisibility" type="button"
			class="sensitive-toggle-button p-button p-component p-button-text"
			[attr.aria-label]="isRevealed() ? 'Hide value' : 'Show value'" (click)="toggleVisibility()">
			<i class="pi" [ngClass]="isRevealed() ? 'pi-eye-slash' : 'pi-eye'">
			</i>
		</button>
	</div>
</div>
}

<field-validation-message [field]="field">
</field-validation-message>